import { useState, useEffect } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { gridSpacing } from 'app/constant';
import { deepPurple } from '@mui/material/colors';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';

const TeamIncentiveProfit = () => {
    const token = useSelector(selectCurrentToken);

    const [teamIncentiveProfitDetails, setTeamIncentiveProfitDetails] = useState([]);
    const [clientName, setclientName] = useState('');
    const [fetchingTeamIncentiveProfit, setFetchingTeamIncentiveProfit] = useState(false);

    const [generateBtnDisabled, setGenerateBtnDisabled] = useState(false);

    const { data: ClientNames } = useFetchData('/Customer/LoginUserNames');

    const fetchTeamIncentiveProfitDetails = async () => {
        let teamIncentiveProfitURL = `/AmbassadorProfitDetails/All?`;
        if (clientName !== '') {
            teamIncentiveProfitURL += `&loginUserName=${clientName}`;
        }

        setFetchingTeamIncentiveProfit(true);
        try {
            const res = await axiosInstance.get(teamIncentiveProfitURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setTeamIncentiveProfitDetails(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchingTeamIncentiveProfit(false);
        }
    };

    const generateAmbassadorIncentive = async () => {
        setGenerateBtnDisabled(true);
        try {
            const res = await axiosInstance.post(
                '/Backend/GenerateAmbassadorIncentive',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Generated Ambassador Incentive successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setGenerateBtnDisabled(false);
        }
    };

    useEffect(() => {
        fetchTeamIncentiveProfitDetails();
    }, []);

    return (
        <Grid container item xs={12} padding="20px">
            {/* <InsertDepositRecord clientName={ClientNames} status={DepositStatus} /> */}
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                <Button
                    onClick={() => generateAmbassadorIncentive()}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        // marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                    disabled={generateBtnDisabled}
                >
                    Generate Ambassador Incentive
                </Button>
            </Box>
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={clientName}
                            onChange={(event, newValue) => {
                                setclientName(newValue);
                            }}
                            inputValue={clientName}
                            onInputChange={(event, newInputValue) => {
                                setclientName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={ClientNames}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={12} lg={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                            gap: '15px',
                            width: '50%',
                            marginLeft: 'auto'
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                float: 'right',
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '20px',
                                marginBottom: '30px'
                            }}
                            onClick={() => fetchTeamIncentiveProfitDetails()}
                            disabled={fetchingTeamIncentiveProfit}
                        >
                            Filter
                        </Button>
                        {/* <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '20px',
                                marginBottom: '20px'
                            }}
                            onClick={() => exportDataAsXlsx()}
                            disabled={filterBtnDisabled}
                        >
                            Export Data
                        </Button> */}
                    </Box>
                </Grid>

                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {fetchingTeamIncentiveProfit ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable teamIncentiveProfitDetails={teamIncentiveProfitDetails} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default TeamIncentiveProfit;
